import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import kanbanInfo from '~/assets/underground/controle_frentes_info.svg';

import {
  Card,
  CardBody,
} from '~/components/Card';

import { useTranslation } from 'react-i18next';
import styles from './styles';

const KanbanInfoModal = ({ classes, handleInfoModal }) => {
  const { t: translate } = useTranslation();

  const subtitleList = [
    translate('common:Code'),
    translate('common:Priority'),
    translate('common:SubElement'),
    translate('common:CodeAndCodeDuration'),
    translate('common:CyclesNumberKanban'),
    translate('common:CodeDateAndTime'),
    translate('common:Highlight'),
  ];

  return (
    <div className={classes.modalWrapper}>
      <Card className={classes.modalCard}>
        <div className={classes.header}>
          <IconButton
            onClick={handleInfoModal}
            classes={{ root: classes.closeButton }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        <CardBody className={classes.modalContent}>
          <img src={kanbanInfo} alt="kanbanInfo" className={classes.infoImage} />

          <div className={classes.legendMainContainer}>
            <Typography className={classes.legendTitle}>
              {translate('common:Legend')}
            </Typography>
            {
              subtitleList.map((el, index) => (
                <div className={classes.legendRow}>
                  <div className={classes.legendIndex}>
                    <span>{index + 1}</span>
                  </div>
                  <Typography className={classes.legend}>{el}</Typography>
                </div>
              ))
            }
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

KanbanInfoModal.propTypes = {
  classes: PropTypes.object.isRequired,
  handleInfoModal: PropTypes.func,
};

KanbanInfoModal.defaultProps = {
  handleInfoModal: null,
};

export default withStyles(styles)(KanbanInfoModal);
